





































































import Vue, { PropType } from 'vue';
import { Brand } from 'mostra';

export type DataType = {
  innerValue: string|number;
}

export default Vue.extend({
  name: 'GItemTopTable',
  props: {
    // owner: {
    //   type: String as PropType<string>,
    //   required: true,
    // },
    brands: { type: Array as PropType<Brand[]>, default: () => ([]) },
    listItems: { type: Array as PropType<object[]>, default: () => [] },
    toEditData: { type: Function as PropType<Function>, default: () => false },
    copyItem: { type: Function as PropType<Function>, default: () => false },
    previewItem: { type: Function as PropType<Function>, default: () => false },
  },
  methods: {
    getBrandName(id: string | null) {
      const brandData = this.brands.filter(
        (brand) => brand.id === id,
      )[0];
      if (!brandData) return null;
      return brandData.data.base.name;
    },
  },
});
